import { useAppSelector } from 'hooks/reduxHooks'
import { useMemo } from 'react'

export function getAccommodationMapSearchPath(pathname: string): string {
  return pathname.includes('/homes-and-villas') ? '/search/homes-and-villas/map' : '/search/map'
}

function useAccommodationMapSearchPath(): string {
  const pathname = useAppSelector(state => state.router.location.pathname)

  return useMemo(() => getAccommodationMapSearchPath(pathname), [pathname])
}

export default useAccommodationMapSearchPath
